import * as React from 'react';
import './Table.scss';
interface DefaultProps {
  children: React.ReactNode;
}

const Table: React.FC<DefaultProps> = ({ children, ...props }) => (
  <table {...props} className="table Table">
    {children}
  </table>
);
const TableRow: React.FC<DefaultProps & React.HTMLAttributes<HTMLTableRowElement>> = ({ children, ...props }) => (
  <tr {...props}>{children}</tr>
);
const TableHeader: React.FC<DefaultProps & React.HTMLAttributes<HTMLTableSectionElement>> = ({
  children,
  ...props
}) => <thead {...props}>{children}</thead>;
const TableHeadCol: React.FC<DefaultProps & React.ThHTMLAttributes<HTMLTableCellElement>> = ({
  children,
  ...props
}) => <th {...props}>{children}</th>;
const TableCol: React.FC<DefaultProps & React.ThHTMLAttributes<HTMLTableCellElement>> = ({ children, ...props }) => (
  <td {...props}>{children}</td>
);
const TableBody: React.FC<DefaultProps & React.HTMLAttributes<HTMLTableSectionElement>> = ({ children, ...props }) => (
  <tbody {...props}>{children}</tbody>
);
export { Table, TableRow, TableHeader, TableHeadCol, TableCol, TableBody };
export default Table;
